export default "__VITE_ASSET__Cau3RK1B__"